import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { E11AlertModule } from '@engineering11/ui-lib/e11-alert'
import { E11AvatarModule } from '@engineering11/ui-lib/e11-avatar'
import { E11BackdropModule } from '@engineering11/ui-lib/e11-backdrop'
import { E11BadgeModule } from '@engineering11/ui-lib/e11-badge'
import { E11ButtonModule } from '@engineering11/ui-lib/e11-button'
import { E11CardModule } from '@engineering11/ui-lib/e11-card'
import { E11ChartPercentageModule } from '@engineering11/ui-lib/e11-chart-percentage'
import { E11ChipModule } from '@engineering11/ui-lib/e11-chip'
import { E11ConfirmationModule } from '@engineering11/ui-lib/e11-confirmation'
import { E11CountdownModule } from '@engineering11/ui-lib/e11-countdown'
import { E11DirectivesModule } from '@engineering11/ui-lib/e11-directives'
import { E11DividerModule } from '@engineering11/ui-lib/e11-divider'
import { E11EmptyStateModule } from '@engineering11/ui-lib/e11-empty-state'
import { E11ErrorMessagesModule } from '@engineering11/ui-lib/e11-error-messages'
import { E11FileViewerModule } from '@engineering11/ui-lib/e11-file-viewer'
import { E11DynamicFormModule } from '@engineering11/ui-lib/e11-form-builder'
import { E11IconModule } from '@engineering11/ui-lib/e11-icon'
import { E11ImageModule } from '@engineering11/ui-lib/e11-image'
import { E11IndicatorModule } from '@engineering11/ui-lib/e11-indicator'
import { E11InfotipModule } from '@engineering11/ui-lib/e11-infotip'
import { E11InputModule } from '@engineering11/ui-lib/e11-input'
import { E11InputCheckboxModule } from '@engineering11/ui-lib/e11-input-checkbox'
import { E11InputErrorsModule } from '@engineering11/ui-lib/e11-input-errors'
import { E11LoaderModule } from '@engineering11/ui-lib/e11-loader'
import { E11LoaderEllipsisModule } from '@engineering11/ui-lib/e11-loader-ellipsis'
import { E11LoaderLineModule } from '@engineering11/ui-lib/e11-loader-line'
import { E11LoaderSpinnerModule } from '@engineering11/ui-lib/e11-loader-spinner'
import { E11ModalModule } from '@engineering11/ui-lib/e11-modal'
import { E11NavLeftModule } from '@engineering11/ui-lib/e11-nav-left'
import { E11OverflowModule } from '@engineering11/ui-lib/e11-overflow'
import { E11PaginationModule } from '@engineering11/ui-lib/e11-pagination'
import { E11PanelModule } from '@engineering11/ui-lib/e11-panel'
import { E11PhoneNumberModule } from '@engineering11/ui-lib/e11-phone-number'
import { E11PopoverModule } from '@engineering11/ui-lib/e11-popover'
import { E11ProfilePicModule } from '@engineering11/ui-lib/e11-profile-pic'
import { E11RadioInputModule } from '@engineering11/ui-lib/e11-radio-input'
import { E11ReadMoreModule } from '@engineering11/ui-lib/e11-read-more'
import { E11SelectModule } from '@engineering11/ui-lib/e11-select'
import { E11SelectorModule } from '@engineering11/ui-lib/e11-selector'
import { E11SideOverModule } from '@engineering11/ui-lib/e11-side-over'
import { E11SidesheetModule } from '@engineering11/ui-lib/e11-sidesheet'
import { E11SwitchModule } from '@engineering11/ui-lib/e11-switch'
import { E11TabsModule } from '@engineering11/ui-lib/e11-tabs'
import { E11TabsOnlyModule } from '@engineering11/ui-lib/e11-tabs-only'
import { E11TagModule } from '@engineering11/ui-lib/e11-tag'
import { E11TextEditorModule } from '@engineering11/ui-lib/e11-text-editor'
import { E11TextareaModule } from '@engineering11/ui-lib/e11-textarea'
import { E11TitleBarModule } from '@engineering11/ui-lib/e11-title-bar'
import { E11TooltipModule } from '@engineering11/ui-lib/e11-tooltip'
import { LoaderLinkComponent, LoaderLinkGlobalComponent } from 'shared-lib'

const ImportExportModules = [
  // New UI lib modules
  E11AvatarModule,
  E11BackdropModule,
  E11BadgeModule,
  E11ButtonModule,
  E11CardModule,
  E11ChipModule,
  E11DividerModule,
  E11DynamicFormModule,
  E11EmptyStateModule,
  LoaderLinkComponent,
  LoaderLinkGlobalComponent,
  E11LoaderEllipsisModule,
  E11LoaderSpinnerModule,
  E11LoaderModule,
  E11LoaderLineModule,
  E11ProfilePicModule,
  E11RadioInputModule,
  E11InputModule,
  E11TooltipModule,
  E11PanelModule,
  E11TitleBarModule,
  E11PhoneNumberModule,
  E11SideOverModule,
  E11ConfirmationModule,
  E11ImageModule,
  E11ReadMoreModule,
  E11SidesheetModule,
  E11TextEditorModule,
  E11CountdownModule,
  E11AlertModule,
  E11TitleBarModule,
  E11ModalModule,
  E11ErrorMessagesModule,
  E11InputErrorsModule,
  E11SelectModule,
  E11NavLeftModule,
  E11SwitchModule,
  E11TabsModule,
  E11TagModule,
  E11TabsOnlyModule,
  E11DirectivesModule,
  E11PopoverModule,
  E11IndicatorModule,
  E11TextareaModule,
  E11InfotipModule,
  E11InputCheckboxModule,
  E11IconModule,
  E11SelectorModule,

  E11PaginationModule,
  E11ChartPercentageModule,
  E11FileViewerModule,
  E11OverflowModule,
]

@NgModule({
  declarations: [],
  imports: [CommonModule, ...ImportExportModules],
  exports: [...ImportExportModules],
})
export class UiComponentLibraryModule {}
